import { AnimatePresence, motion } from 'motion/react';
import { FC } from 'react';

import CardFlipper from '@/components/CardFlipper.tsx';
import TaskListItem from '@/components/TaskModal/TaskListItem.tsx';
import Heading4 from '@/components/text/Heading4.tsx';

import useBreakpoints from '@/hooks/useBreakpoints.ts';

import { TaskModalMode } from '@/models/TaskModalMode.ts';

import { useTaskViewStore } from '@/stores/taskViewStore.ts';

const TaskList: FC = () => {
    const selected_task_id = useTaskViewStore((state) => state.selected_task_id);
    const task_modal_mode = useTaskViewStore((state) => state.task_modal_mode);
    const show_task_list = useTaskViewStore((state) => state.show_task_list);
    const task_list = useTaskViewStore((state) => state.task_list);
    const task_index = task_list.findIndex((task) => task.id === selected_task_id);
    const disabled = task_modal_mode === TaskModalMode.EDITOR;

    const handleScroll = (index?: number): void => {
        if (index === undefined) return;

        useTaskViewStore.setState({ selected_task_id: task_list[index].id });
    };

    const selectTask = (id: string, instance_id: string): void =>
        useTaskViewStore.setState({ selected_task_id: id, selected_task_instance_id: instance_id });

    const { is_less_than_xl } = useBreakpoints();

    if (is_less_than_xl) return undefined;

    return (
        <div className="absolute top-0 -z-10 flex h-full w-64 justify-end gap-2">
            <AnimatePresence>
                {show_task_list && (
                    <motion.div
                        key="task_list"
                        initial={{ x: 0, opacity: 0 }}
                        animate={{ x: -275, opacity: 1 }}
                        exit={{ x: 0, opacity: 0, transition: { opacity: { delay: 0 } } }}
                        transition={{
                            x: {
                                duration: 0.3,
                                delay: 0.1,
                            },
                            opacity: { duration: 0.3, delay: 0.2 },
                        }}
                        className="flex w-full flex-col items-center"
                    >
                        <Heading4 className="font-bold text-white">{`${task_index + 1} / ${task_list.length}`}</Heading4>
                        <CardFlipper
                            isVertical
                            isInfinite
                            isCentered
                            slidesToScroll={1}
                            slidesToShow={5}
                            classNames={{
                                root: 'h-full w-full rounded-md bg-transparent p-2',
                                wrapper: 'h-[70vh]',
                            }}
                            gap={4}
                            currentIndex={task_index}
                            onScroll={handleScroll}
                            enableKeyboardNavigation={!disabled}
                            enableWheelNavigation={!disabled}
                        >
                            {task_list.map((item) => (
                                <TaskListItem
                                    key={item.id}
                                    task={item}
                                    isSelected={selected_task_id === item.id}
                                    onClick={selectTask}
                                    disabled={disabled}
                                />
                            ))}
                        </CardFlipper>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default TaskList;
